import { MusicIcon } from './MusicIcon';

/** Auto-room names alone carry a server-generated icon prefix. Personal names stay verbatim. */
export function RoomName({ name, isAutoRoom = false }: { name: string; isAutoRoom?: boolean }) {
  const prefix = isAutoRoom ? /^((?:\p{Extended_Pictographic}|\p{Regional_Indicator})(?:[\uFE0F\u200D]|\p{Extended_Pictographic}|\p{Emoji_Modifier}|\p{Regional_Indicator})*)\s+(.+)$/u.exec(name) : null;
  return prefix ? <><MusicIcon name={prefix[1]}/>{' '}{prefix[2]}</> : <>{name}</>;
}
